import {
  type EncounterSpecialty as MastraEncounterSpecialty,
  MASTRA_STUDIO_DEFAULT_BASE,
  getInvestigatorMastraRunUrl as getInvestigatorMastraRunUrlShared,
  getMastraRunUrl as getMastraRunUrlShared,
  getMastraWorkflowRunUrl as getMastraWorkflowRunUrlShared,
} from "@smartmed/mastra-studio";

import type { Database } from "@/integrations/supabase/types";

type EncounterSpecialty = Database["public"]["Enums"]["encounter_speciality_type"];

export const MASTRA_STUDIO_BASE_URL = import.meta.env.VITE_MASTRA_STUDIO_BASE_URL ?? MASTRA_STUDIO_DEFAULT_BASE;

export function getMastraRunUrl(workflowName: string, runId: string): string {
  return getMastraRunUrlShared(workflowName, runId, MASTRA_STUDIO_BASE_URL);
}

export function getMastraWorkflowRunUrl(specialty: EncounterSpecialty | null | undefined, runId: string): string {
  return getMastraWorkflowRunUrlShared(
    specialty as MastraEncounterSpecialty | null | undefined,
    runId,
    MASTRA_STUDIO_BASE_URL,
  );
}

export function getInvestigatorMastraRunUrl(runId: string): string {
  return getInvestigatorMastraRunUrlShared(runId, MASTRA_STUDIO_BASE_URL);
}
